import React, { useEffect, useCallback } from "react";
import { useRoute, RouteProp, useNavigation, NavigationProp } from "@react-navigation/native";
import { RootStackParamList } from "../navigation/AppNavigator.web";
import ChatWindowContainer from "../containers/companion/ChatWindowContainer";
import { useGetUserLatestCompanionChatQuery, useGetCompanionChatByIdQuery } from "../graphql/generated/graphql";
import CompanionLayout from "../layouts/CompanionLayout";

function CompanionView() {
  const route = useRoute<RouteProp<RootStackParamList, "Companion">>();
  const navigation = useNavigation<NavigationProp<RootStackParamList>>();
  const { chatId: routeChatId } = route.params || {};

  const { data: routeChatData, loading: routeChatLoading } = useGetCompanionChatByIdQuery({
    skip: !routeChatId,
    variables: {
      id: routeChatId!,
    },
    fetchPolicy: "network-only",
  });

  const routeChatExists =
    routeChatId &&
    !routeChatLoading &&
    routeChatData?.getCompanionChatById !== null &&
    routeChatData?.getCompanionChatById !== undefined;
  const shouldUseRouteChat = !!routeChatExists;

  const { data: chatsData, loading: chatsLoading } = useGetUserLatestCompanionChatQuery({
    skip: shouldUseRouteChat || (routeChatId && routeChatLoading),
  });

  const chatId = shouldUseRouteChat ? routeChatId! : chatsData?.getUserLatestCompanionChat || null;

  useEffect(() => {
    if (!shouldUseRouteChat && !chatsLoading && chatsData?.getUserLatestCompanionChat) {
      const latestChatId = chatsData.getUserLatestCompanionChat;
      navigation.setParams({ chatId: latestChatId });
    }
  }, [shouldUseRouteChat, chatsLoading, chatsData, navigation]);

  const handleChatIdChange = useCallback(
    (newChatId: string) => {
      navigation.setParams({ chatId: newChatId });
    },
    [navigation]
  );

  return (
    <CompanionLayout>
      <ChatWindowContainer chatId={chatId} onChatIdChange={handleChatIdChange} />
    </CompanionLayout>
  );
}

export default CompanionView;
